/** external **/
import React from "react";
import { Modal } from "@toddle-edu/ds-web";

/** internal **/
import { useI18n } from "Hooks";
import ViewerComponent from "UIComponents/TheatreModeV2/ViewerComponent";

const AssessmentToolsModal = props => {
  const { onDiscardDirectly } = props;
  const { t } = useI18n(["worksheet"]);

  return (
    <Modal onClose={onDiscardDirectly} width={1480}>
      <Modal.Header
        title={t("worksheet:worksheet_assessment_tools")}
        style={{
          padding: "16px 24px",
          fontSize: "16px",
          lineHeight: "24px",
          height: "68px",
        }}
        hasSeparator={true}
      />
      <ViewerComponent {...props} />
    </Modal>
  );
};

export default AssessmentToolsModal;
